import { ContentFragmentType } from './Content';
export const RootHelper = {
    build: (id, sections) => ({
        _id: id,
        type: ContentFragmentType.Root,
        value: { sections },
    }),
    isRoot: (fragment) => fragment.type === ContentFragmentType.Root,
};
